import config from '../../config.json';
export default { ...Object.assign({}, config['common'], config['resources-manager-front']) };
